import * as yup from 'yup';

export interface ArkPesFormValues {
  clientId: string;
}

export function arkPesConfigSchema() {
  return yup.object({
    clientId: yup.string().trim().required('Client ID is required'),
  });
}

export function getDefaultArkPesConfig(): ArkPesFormValues {
  return {
    clientId: '',
  };
}
